import { RequestTypes } from '../../../hooks/useRequest'

export const GENERATION_API_PREFIX = '/api/green-tools/v1/'
export const GENERATION_GRAPH_BLOCK = 'frontpage-stats'

export const EXTENSION_API_PREFIX = '/api/extension/v1/'
export const GREEN_TOOLS_STATS = 'extension/stats/green-tools'
export const GREEN_TOOLS_STATS_EXPIRED = 'extension/stats/green-tools/expired'

export const getGraphData = {
    link: `${GENERATION_API_PREFIX}${GENERATION_GRAPH_BLOCK}`,
    method: RequestTypes.get,
}

export const getGreenToolsStats = {
    link: `${EXTENSION_API_PREFIX}${GREEN_TOOLS_STATS}`,
    method: RequestTypes.get,
}

export const getGreenToolsStatsExpired = {
    link: `${EXTENSION_API_PREFIX}${GREEN_TOOLS_STATS_EXPIRED}`,
    method: RequestTypes.get,
}
